import React from 'react'
import './TransactionSetting.css'
function TransactionSettings(props) {
  return (
    <div className='TransactionSettings'>
           <div className='TransactionSettings-overlay' onClick={()=>props.onClose()}/>
       
            <div className='Transaction-Body'>
                <div className='Transaction-inner-body'>
            <p className='Transaction-heading'>Transaction Settings</p>
            <p className='Transaction-subtext'>Slippage tolerance:</p>

            <div className='Transaction-AmountContainer'>
                <div className='Transaction-Button' onClick={()=>props.setSlipage(10)}>
                    <p>Auto</p>
                </div>
                <input placeholder='10%' value={props.slipage} onChange={(e)=>props.setSlipage(e.target.value)}  type='number'/>
                <div>

                </div>


            </div>
            </div>
            </div>
       
    </div>
  )
}

export default TransactionSettings